<template>
  <div>
    <NarrativeAdd />
  </div>
</template>

<script>
import NarrativeAdd from "./NarrativeAdd.vue";

export default {
  components: {
    NarrativeAdd,
  },

  data() {
    return {};
  },
};
</script>
